import request from '@/utils/request'

export function login(data){
  return request({
    url: '/wwqb/user/login',
    method: 'post',
    data: data
  })
}

export function logout(){
  return request({
    url: '/wwqb/user/logout',
    method: 'post'
  })
}

export function getUserInfo(){
  return request({
    url: '/wwqb/user/info/get',
    method: 'get',
  })
}

export function getLogs(data){
  return request({
    url: '/wwqb/home/log/list',
    method: 'post',
    data: data
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}